<template>
  <div class="users-manager">
    <p>Le composant de gestion des utilisateurs sera intégré ici. Pour l'instant, utilisez la page /users existante.</p>
  </div>
</template>

<script setup>
// Ce composant sera développé ultérieurement
// Pour l'instant, la gestion des utilisateurs reste sur /users
</script>

<style scoped>
.users-manager {
  padding: 2rem;
  text-align: center;
  color: #6c757d;
}
</style>
